<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm04_cont"><a id="page_5"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm05_for#ch00_fm05_for"><strong>Foreword</strong></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm06_intro#ch00_fm06_intro"><strong>Introduction</strong></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm07_note#ch00_fm07_note"><strong>Publisher’s Note</strong></a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">Chapter 1: Everything You Ever Wanted to Ask Your Doctor About Acid Reflux</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2: Everything You Ever Wanted to Know About Food and Acid Reflux</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3: The 10 Food Steps to Freedom</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4: Waiting to Lose Weight</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" id="page_6" title="Link target outside of Sample"></span><a>Chapter 5: How to Have a Heartburn-Free Holiday</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6: Recipes You Can’t Live Without</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7: Restaurant Rules</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08_index#ch08_index" title="Link target outside of Sample"><strong>Index</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09_abt#ch09_abt" title="Link target outside of Sample"><strong>About the Author</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_cont.vue?7e9ec8b9